/* @flow */

import React from 'react'
import NavigationButtons from 'atpjs/components/navigation_buttons'
import Error from 'atpjs/components/form/error'
import i18n from 'atpjs/helpers/i18n'
import { validationHasError } from 'atpjs/validation/validations'
import { equals, validDate } from 'atpjs/validation/validators'
import Step from 'tve/views/step'
import Application from 'tve/components/application'
import AppointmentGrid from 'tve/components/appointment_grid'
import AppointmentGridHeader from 'tve/components/appointment_grid_header'
import AppointmentGridFooter from 'tve/components/appointment_grid_footer'
import AppointmentSummary from 'tve/components/appointment_summary'
import { loadSlots } from 'tve/api/atp'
import { computePhone } from 'tve/helpers/phone'
import { getWeeksSlotsHistory } from 'tve/helpers/calendar'

import type { PrefixType } from 'atpjs/helpers/i18n'

const t = i18n.prefix(['update'])

class Update extends Step {
  sendData = true
  weeksSlotsHistory = []

  validations(_trans: PrefixType) {
    return {
      event: {
        available: equals(true),
        end: validDate(),
        start: validDate()
      }
    }
  }

  cancelHandler = () => {
    const { changeStep } = this.props
    changeStep('confirmation')
  }

  nextHandler = () => {
    this.next('confirmation')
  }

  loadSlots = (date) => {
    const appointment = this.getData(['appointment'])
    const topic = appointment.getIn(['topic', 'id'])
    const topics = appointment.get('topics').map((topic) => topic.get('id'))
    const orderedTopics = topics.delete(topics.indexOf(topic)).unshift(topic)
    const slots = loadSlots(
      date,
      appointment.get('language'),
      appointment.get('medium'),
      orderedTopics.toJS(),
      appointment.get('branchCode'),
      appointment.get('userEmail'),
      appointment.get('street'),
      appointment.get('zip'),
      appointment.get('city')
    )
    this.weeksSlotsHistory = getWeeksSlotsHistory(this.weeksSlotsHistory, date, slots)
    return slots
  }

  selectBranchHandler = (_branchId) => {
    // we can't switch branches on UKB in the Appointment Grid,
    // if we could, we would need to set data.branch to a Branch object which
    // has the branchCode attribute! The ID alone is not enough.
  }

  render() {
    const inputSetProps = this.inputSetProps()
    const eventInputSetProps = inputSetProps(['event'])
    const data = this.getHandler()
    const advisor = data.get('appointment')?.get('user')
    const customerType = data
      .get('appointment')
      ?.get('topic')
      ?.get('client_segment_code')
    const branch = data.get('appointment')?.get('branch')
    const medium = data.get('appointment')?.get('medium')
    const value = eventInputSetProps.value
    const phone = computePhone(data)

    return (
      <Application title={t(['title'])} name={i18n.trans(['tve', 'title'])}>
        <form onSubmit={this.onSubmit}>
          <div className="atp-notification">
            <span>Keine früheren Termine möglich. Beratung am Samstag bitte telefonisch vereinbaren: </span>
            <a href="tel:+41418756000" className="atp-notification__bold-text">
              Tel. +41 41 875 60 00
            </a>
          </div>
          <br />
          <AppointmentGrid
            weeksSlotsHistory={this.weeksSlotsHistory}
            {...eventInputSetProps}
            untilDays={14}
            phone={phone}
            medium={medium || 'bank'}
            loadSlots={this.loadSlots}
            showNoEvents={true}
            selectBranch={this.selectBranchHandler}
            renderHeader={(props) => {
              return <AppointmentGridHeader {...props} advisor={advisor} branch={branch} customerType={customerType} />
            }}
            renderFooter={(props) => {
              return <AppointmentGridFooter {...props} branch={branch} customerType={customerType} />
            }}
          />
          <Error
            errorMessage={
              validationHasError(eventInputSetProps.errorMessage) && i18n.trans(['attributes', 'errors', 'event'])
            }
          />
          {value && (
            <AppointmentSummary
              advisor={advisor}
              branch={branch}
              customerType={customerType}
              medium={medium}
              value={value}
            />
          )}

          <br />
          <NavigationButtons
            nextAction={this.nextHandler}
            previousAction={this.cancelHandler}
            order={['previous', 'next']}
            nextLabel={i18n.trans(['buttons', 'moveNow'])}
            previousProps={{ className: ' atp-margin-right-xxs' }}
          />
        </form>
      </Application>
    )
  }
}

export default Update
